import React, { useEffect, useState } from "react";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import BlogAside from "../blog/blog-aside/BlogAside";
import BlogCommentForm from "./blog-comment-form/BlogCommentForm";
import BlogUsersComment from "./blog-users-comment/BlogUsersComment";
import { Helmet } from "react-helmet";
import { useGetBlogDetailsQuery } from "../products/productSlice";
import { useParams } from "react-router-dom";
import axios from "axios";
import { base_url } from "../../server";
import { useTranslation } from "react-i18next";

// import blog1 from "../../assets/img/serviceList/cagliata.jpg";
// import blog2 from "../../assets/img/serviceList/Indian-Cereals.jpg";
// import blog3 from "../../assets/img/serviceList/Indian-Pulses.jpg";
// import blog4 from "../../assets/img/serviceList/gr5ikknbtygma4krpfai.png";
// import blog5 from "../../assets/img/serviceList/f454dq2nqgkt45dcladv.png";
// import blog6 from "../../assets/img/serviceList/jo1im9jkpkbst0of9sti.png";

const newsArray = [
  {
    id: 1,
    date: "02 Apr",
    // url: blog1,
    title:
      "How to Scale Your PCD Pharma Franchise Business: Tips for Long-Term Success",
    desc: "The pharmaceutical industry in India has grown drastically in the recent past, and it is because of the PCD pharma franchise company model. This model has brought about an edge for entrepreneurs interested..",
    link: "Read more",
  },
  {
    id: 2,
    date: "02 Apr",
    // url: blog2,
    category: "Blog",
   
    title: "Benefits of Starting a PCD Pharma Franchise Business in India",
    desc: "The pharmaceutical industry in India has witnessed a fast-paced growth rate. Moreover, the rising demand for quality healthcare has generated many business opportunities for flourishing. Among such an opportunity is PCD pharma franchise in India.",
    link: "Read more",
  },
  {
    id: 3,
    date: "02 Apr",
    // url: blog3,
    category: "Blog",
    title: "PCD Pharma Franchise in India: Strategic Vision for Contemplating the Year 2025?",
    desc: "One of the biggest and most exciting areas for entrepreneurs in India is in the form of Propaganda Cum Distribution franchise or PCD franchise business in the Global Pharma franchise market. For new investors",
    link: "Read more",
  },
  {
    id: 4,
    date: "02 Apr",
    // url: blog4,
   
    title: "How Wholesale Pharmacy Distributors Enhance Healthcare Accessibility in India",
    desc: "One of the biggest and most exciting areas for entrepreneurs in India is in the form of Propaganda Cum Distribution franchise or PCD franchise business in the Global Pharma franchise market. For new investors",
    link: "Read more",
  },
  {
    id: 5,
    date: "02 Apr",
    // url: blog5,
    category: "Blog",
    
    title: "Pharma Franchise",
    desc: "The pharmaceutical industry of India is growing very rapidly especially in regions like Maharashtra because people here are looking out for quality medicines with such an unrelenting and unstoppable demand.",
    link: "Read more",
  },
  
];

function BlogDetail() {
  const params = useParams();

  const [data, setData] = useState(null);
  const [isLoading, setisLoading] = useState(false);

  const token = window.localStorage.getItem("token");
  const baseUrl = base_url();
  const getData = async () => {
    setisLoading(true);
    try {
      const res = await axios.get(`${baseUrl}blogs/${params.id}`, {
        withCredentials: true,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
      });
      setisLoading(false);
      setData(res.data);
    } catch (error) {
      setisLoading(false);
      console.log("Fail to Load Blog Detail !");
    }
  };

  useEffect(() => {
    getData();
  }, []);
  const { t } = useTranslation();
  const [blogData, setBlogData] = useState(newsArray);
  const filterData = blogData.find((item) => {
    console.log(item.id === params.id);

    return item.id == params.id;
  });

  console.log("filterData", filterData);

  return (
    <>
      <Helmet>
        <title>Blog Detail | Al-Saniya Food Stuff Trading LLC</title>
        <meta name="keyword" content="Omega Infrastructruture Commercial LLC" />
        <meta
          name="description"
          content="Omega Infrastructruture Commercial LLC"
        />
      </Helmet>
      <Breadcrumb title="Blog Detail" t={t} />
      <section className="blogDetailSec sectionPD p-30">
        <div className="container">
          {isLoading && (
            <div className="preloaderCount">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-8">
              <div className="blogDetailInfo">
                <div className="blogDetailContent">
                  <figure className="currentBlogImg">
                    {/* <img
                      src={filterData?.url}
                      alt="Blog"
                      className="img-fluid"
                    /> */}
                  </figure>
                  <h4>{filterData.title}</h4>
                  <p>{filterData.desc}</p>
                </div>
                {/* <BlogUsersComment data={data} /> */}
                <BlogCommentForm />
              </div>
            </div>
            <div className="col-md-4">
              <BlogAside t={t} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
